module.exports = __webpack_public_path__ + "img/CIMBATM.9a98cc3e.png";